module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-05-1ed3a2852c08e270a6d059d4a557f143.jpg";